export enum events {
  login = 'login',
  bid = 'bid',
  cancelBid = 'cancel_bid',
  finalize = 'finalize',
  transfer = 'transfer',
}
